import PreviewInfo from './PreviewInfo';



export default PreviewInfo;
